import $ from 'jquery';
import initContextMenu from './bootstrap.context.menu';

initContextMenu($);
